import React from 'react';
import { formatTimeAgo } from '../utils/date';

export default function SyncButton({ onSync, syncing, lastSyncAt }) {
  return (
    <div style={styles.wrapper}>
      <button
        type="button"
        onClick={() => { if (!syncing && typeof onSync === 'function') onSync(); }}
        disabled={syncing}
        style={{ ...styles.btn, opacity: syncing ? 0.7 : 1 }}
      >
        <span style={{ ...styles.icon, ...(syncing ? styles.iconSpinning : null) }} aria-hidden>🔄</span>
        <span>{syncing ? 'Synchronisation…' : 'Synchroniser'}</span>
      </button>
      {lastSyncAt && !syncing && (
        <span style={styles.timeAgo}>Mis à jour {formatTimeAgo(lastSyncAt)}</span>
      )}
      <style>{`
        @keyframes revyoSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
  },
  btn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '8px 14px',
    background: '#FFFFFF',
    border: '1px solid #E5E5E0',
    borderRadius: 999,
    fontSize: 13,
    fontWeight: 600,
    color: '#1A1A1A',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  icon: {
    display: 'inline-block',
    fontSize: 14,
    lineHeight: 1,
  },
  iconSpinning: {
    animation: 'revyoSpin 1s linear infinite',
  },
  timeAgo: {
    fontSize: 11,
    color: '#9A9A9A',
  },
};
